{
  "传感器：同一次抓取的四种看法 · 物理AI实验室 Lab 1.3": {
    "en": "Sensors: four views of one grasp · Physical AI Lab 1.3",
    "ja": "センサー：同じ把持を四通りに見る · Physical AI Lab 1.3"
  },
  "同一次抓取，四种看法": {
    "en": "One grasp, four views",
    "ja": "同じ把持、四つの見え方"
  },
  "手伸向杯子、碰上、抓起、差点滑掉。相机、深度、力、触觉，同一时刻<span style=\"color:var(--see)\">看到</span>的东西完全不同。": {
    "en": "Reach, touch, lift, nearly slip. At the same moment, camera, depth, force and touch each <span style=\"color:var(--see)\">see</span> something entirely different.",
    "ja": "手がカップに伸び、触れ、持ち上げ、滑りかける。カメラ・深度・力・触覚が同じ瞬間に<span style=\"color:var(--see)\">見る</span>ものは、まったく違います。"
  },
  "传感器 · sensor view": {
    "en": "Sensor view",
    "ja": "センサー · sensor view"
  },
  "彩色": {
    "en": "Colour",
    "ja": "カラー"
  },
  "深度": {
    "en": "Depth",
    "ja": "深度"
  },
  "力": {
    "en": "Force",
    "ja": "力"
  },
  "触觉": {
    "en": "Touch",
    "ja": "触覚"
  },
  "全部": {
    "en": "All",
    "ja": "すべて"
  },
  "彩色 · 目标": {
    "en": "Colour · target",
    "ja": "カラー · 目標"
  },
  "深度 · 到杯子": {
    "en": "Depth · to the cup",
    "ja": "深度 · カップまで"
  },
  "力 · 两指合计": {
    "en": "Force · both fingers",
    "ja": "力 · 二指の合計"
  },
  "触觉 · 接触面": {
    "en": "Touch · contact area",
    "ja": "触覚 · 接触面"
  },
  "指尖力 · fingertip force": {
    "en": "Fingertip force",
    "ja": "指先の力 · fingertip force"
  },
  "左指": {
    "en": "Left",
    "ja": "左指"
  },
  "右指": {
    "en": "Right",
    "ja": "右指"
  },
  "托住杯子至少要 — N": {
    "en": "To hold the cup: at least — N",
    "ja": "カップを支えるには最低 — N"
  },
  "模拟数值 · 虚拟场景与简化接触模型": {
    "en": "Simulated values · virtual scene, contact model",
    "ja": "シミュレーション値 · 仮想シーンと簡易接触モデル"
  },
  "模拟数值 · 简化接触模型": {
    "en": "Simulated values · simple contact model",
    "ja": "シミュレーション値 · 簡易接触モデル"
  },
  "触觉贴片 · tactile pad (12 × 20)": {
    "en": "Tactile pad (12 × 20)",
    "ja": "触覚パッド · tactile pad (12 × 20)"
  },
  "接触 0 格": {
    "en": "0 cells",
    "ja": "接触 0 マス"
  },
  "接触 {0} 格": {
    "en": "{0} cells",
    "ja": "接触 {0} マス"
  },
  "{0} 格": {
    "en": "{0} cells",
    "ja": "{0} マス"
  },
  "打滑！": {
    "en": "Slipping!",
    "ja": "滑り！"
  },
  "接近": {
    "en": "Approach",
    "ja": "接近"
  },
  "接触": {
    "en": "Contact",
    "ja": "接触"
  },
  "抓起": {
    "en": "Lift",
    "ja": "持ち上げ"
  },
  "轻推·打滑": {
    "en": "Tap·slip",
    "ja": "押し·滑り"
  },
  "收紧": {
    "en": "Tighten",
    "ja": "締める"
  },
  "放下": {
    "en": "Set down",
    "ja": "置く"
  },
  "播放": {
    "en": "Play",
    "ja": "再生"
  },
  "显示数值": {
    "en": "Show values",
    "ja": "数値を表示"
  },
  "打滑演示 ▸": {
    "en": "Slip demo ▸",
    "ja": "滑りのデモ ▸"
  },
  "切换视图 · 拖时间轴 · 拖动空白处旋转视角": {
    "en": "Switch views · drag the timeline · drag empty space to orbit",
    "ja": "表示を切り替え · タイムラインをドラッグ · 空いた所をドラッグして視点を回す"
  },
  "RGB CAMERA · 彩色": {
    "en": "RGB CAMERA",
    "ja": "RGB CAMERA · カラー"
  },
  "DEPTH · 深度": {
    "en": "DEPTH",
    "ja": "DEPTH · 深度"
  },
  "FORCE · 指尖力": {
    "en": "FORCE · FINGERTIPS",
    "ja": "FORCE · 指先の力"
  },
  "TACTILE · 触觉": {
    "en": "TACTILE",
    "ja": "TACTILE · 触覚"
  },
  "RGB | DEPTH · 同一时刻": {
    "en": "RGB | DEPTH · SAME MOMENT",
    "ja": "RGB | DEPTH · 同じ瞬間"
  },
  "托住杯子，每根手指至少要 {0}": {
    "en": "To hold the cup, each finger needs at least {0}",
    "ja": "カップを支えるには、指一本あたり最低 {0}"
  },
  "（被轻推了一下）": {
    "en": "(tapped)",
    "ja": "（軽く押された）"
  },
  "! SLIP 打滑 {0} mm": {
    "en": "! SLIP {0} mm",
    "ja": "! SLIP 滑り {0} mm"
  },
  "滑了 {0} mm，已收紧": {
    "en": "slid {0} mm, tightened",
    "ja": "{0} mm 滑った、締め直した"
  }
}
